import React from 'react';
import { AtlassianAccountOnboardingBanner } from 'app/src/components/AtlassianAccountOnboardingBanner';
import { DesktopSurveyBanner } from 'app/src/components/DesktopSurveyBanner';

export const Banners = () => {
  return (
    <>
      <DesktopSurveyBanner />
      <AtlassianAccountOnboardingBanner />
    </>
  );
};
